import React from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router';

import { Space } from '../../../app/entities/space';

import styles from './seats-progress.module.scss';
type SeatsProgressProps = {
  space: Space;
};

export const SeatsProgress: React.FC<SeatsProgressProps> = observer(({ space }) => {
  const current = space?.seats?.current || 1;
  const limit = space?.seats?.limit || 1;

  return (
    <div className={styles['panel-container']}>
      <header className={styles['panel-header']}>
        <h2 className={styles['header-text']}>Seats used</h2>
      </header>

      <div className={styles['amount-space-container']}>
        <h3 className={styles['amount']}>
          {current} out of {limit} seats used
        </h3>
      </div>

      <footer className={styles['footer']}>
        Invite or remove creators <Link to={'../users'}>here</Link>
      </footer>
    </div>
  );
});
